"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EMAIL_OPENED = exports.EMAIL_CLICKED = exports.EMAIL_SENT = void 0;
exports.EMAIL_SENT = "emailSent";
exports.EMAIL_CLICKED = "emailClicked";
exports.EMAIL_OPENED = "emailOpened";